<template>
  <div class="ov-open" :class="{ 'ov-open--compact': compact }">
    <ul class="ov-open__list">
      <li v-for="row in rows" :key="row.id" class="ov-open__row">
        <app-avatar :name="row.name" :size="28" />
        <span class="ov-open__main">
          <span class="ov-open__labels">
            <span class="ov-open__name">{{ row.name }}</span>
            <span class="ov-open__amount">{{ euro(row.amount) }}</span>
          </span>
          <app-share-bar class="ov-open__bar" :parts="[{ value: row.share, color: 'd-foc' }]" :total="1" />
        </span>
      </li>
      <li v-if="!rows.length" class="ov-open__row">
        <span class="ov-open__slot" aria-hidden="true"><app-icon name="check" :size="16" /></span>
        <span class="ov-open__text">Keine offenen Beträge</span>
      </li>
    </ul>
  </div>
</template>

<script>
// Offene Beträge (Spezifikation 4.1.5, gen_r3.py:618–634): bis zu vier Fahrer mit offenem Saldo (Avatar 28, Name,
// darüber links der Name und rechtsbündig der Betrag mit echtem Minus, darunter der Anteilsbalken wie in den
// Kennzahl-Kacheln (AppShareBar, 6 px, --d-foc auf --d-trk, Breite |v| ÷ max|v|; Kundenwunsch 12.10.2026)); ohne
// offene Beträge Haken und
// „Keine offenen Beträge“. „{r} weitere offen“ bzw. „{n} weitere Fahrer · ausgeglichen“ stehen seit 12.10.2026 im Fuß
// der Karte (HomePage). Zeilen 64, Polster 0 16 (compact/Handy 48, 0 12).
import { formatEuro } from '@/utils/format';

export default {
  name: 'OvOpenAmounts',
  props: {
    // [{ id, name, amount (negativ), share (0–1) }]
    rows: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false }
  },
  methods: {
    euro(x) {
      return formatEuro(x);
    }
  }
};
</script>

<style scoped>
.ov-open {
  padding: 0 16px;
}
.ov-open--compact {
  padding: 0 12px;
}
ul.ov-open__list {
  margin: 0;
  padding: 4px 0;
  list-style: none;
}
.ov-open__row {
  height: 64px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  line-height: 18px;
}
.ov-open--compact .ov-open__row {
  height: 48px;
}
.ov-open__main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ov-open__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  color: var(--ink);
}
.ov-open__bar {
  flex: none;
}
/* Beschriftung über dem Balken: Name links, Betrag rechtsbündig */
.ov-open__labels {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}
.ov-open__amount {
  flex: none;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: var(--ink);
}
.ov-open__slot {
  width: 28px;
  height: 28px;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-3);
}
.ov-open__text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ink-2);
}
.ov-open__muted {
  flex: none;
  white-space: nowrap;
  color: var(--ink-3);
}
</style>
